import React, { useEffect, useState } from 'react';
export const CountdownTimer = () => {
  // Estado para almacenar el tiempo restante
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Comprobamos si hay un tiempo guardado en localStorage
    const savedEndTime = localStorage.getItem('offerEndTime');
    let endTime;
    if (savedEndTime) {
      // Si hay un tiempo guardado, lo usamos
      endTime = parseInt(savedEndTime);
    } else {
      // Si no hay tiempo guardado, creamos uno nuevo (24 horas desde ahora)
      endTime = new Date().getTime() + 24 * 60 * 60 * 1000;
      localStorage.setItem('offerEndTime', endTime.toString());
    }
    // Función para actualizar el contador
    const updateCountdown = () => {
      const now = new Date().getTime();
      const difference = endTime - now;
      // Si el tiempo ha expirado, reiniciamos el contador
      if (difference <= 0) {
        const newEndTime = new Date().getTime() + 24 * 60 * 60 * 1000;
        localStorage.setItem('offerEndTime', newEndTime.toString());
        endTime = newEndTime;
      }
      const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(difference % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    // Actualizamos inmediatamente y luego cada segundo
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    // Limpiamos el intervalo cuando el componente se desmonte
    return () => clearInterval(interval);
  }, []);
  return <div className="bg-[#0C1B2A] text-white py-3 px-4 text-center" data-id="element-102">
      <p className="text-sm mb-2" data-id="element-103">La oferta especial termina en:</p>
      <div className="flex justify-center items-center space-x-2" data-id="element-104">
        <div className="bg-[#D4AF37] text-[#0C1B2A] rounded-md px-3 py-1 font-bold" data-id="element-105">
          {String(timeLeft.hours).padStart(2, '0')}
        </div>
        <span className="text-[#D4AF37] font-bold" data-id="element-106">:</span>
        <div className="bg-[#D4AF37] text-[#0C1B2A] rounded-md px-3 py-1 font-bold" data-id="element-107">
          {String(timeLeft.minutes).padStart(2, '0')}
        </div>
        <span className="text-[#D4AF37] font-bold" data-id="element-108">:</span>
        <div className="bg-[#D4AF37] text-[#0C1B2A] rounded-md px-3 py-1 font-bold" data-id="element-109">
          {String(timeLeft.seconds).padStart(2, '0')}
        </div>
      </div>
    </div>;
};